/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchDates = (data) => {
  return {
    type: actionTypes.GET_DISPLAY_DATES,
    payload: data,
  };
};

//  error msg dispatch function
export const dispatchErrorMsgPaymentSummary = (data) => ({
  type: actionTypes.GET_ERROR_MSG_PAYMENT_SUMMARY,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  //setTimeout(() => {
    //dispatch(dispatchErrorMsgPaymentSummary([]));
  //}, 7000);
  dispatch(
    dispatchErrorMsgPaymentSummary([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ,
  detailScrData: data,
});
// refresh data
export const refreshPaymentSummary = () => ({
  type: actionTypes.SET_REFRESH_DATA,
  payload: {},
});

export const refreshPaymentSummaryDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjPayment = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_PAYMENT,
  payload: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM,
  payload: data,
});
// rebate program name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// report quarter option dispatch
export const dispatchReportOption = (data) => ({
  type: actionTypes.DISPLAY_REPORT_OPTION,
  payload: data,
});

// time period dispatch
export const dispatchTimePeriod = (data) => ({
  type: actionTypes.DISPLAY_TIME_PERIOD,
  payload: data,
});
// payment summary dispatch function
export const dispatchPaymentSummary = (data) => ({
  type: actionTypes.GET_PAYMENT_SUMMARY,
  payload: data,
});
// dispatch quarter from
export const dispatchFromPayment = (data) => ({
  type: actionTypes.GET_FROM_PAYMENT,
  payload: data,
});
// dispatch quarter to
export const dispatchToPayment = (data) => ({
  type: actionTypes.GET_TO_PAYMENT,
  payload: data,
});
// dispatch DRAMS
export const dispatchDRAMS = (data) => ({
  type: actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});

// dispatch state fiscal
export const dispatchStateFiscal = (data) => ({
  type: actionTypes.DISPLAY_STATE_FISCAL,
  payload: data,
});
// dispatch state fiscal
export const dispatchYear = (data) => ({
  type: actionTypes.DISPLAY_YEAR,
  payload: data,
});
// get payment summary

export const getPaymentSummary = (value) => (dispatch) => {
  dispatch(dispatchPaymentSummary([]));
  return axios
    .post(serviceEndPoint.PAYMENT_SUMMARY, value)
    .then((response) => {
      if (response.data.data.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchPaymentSummary(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchPaymentSummary([]));
    });
};
// get DRAMS
export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response.data));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS([]));
    });
};

// get state fiscal year
export const getStateFiscalYear = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_STATE_FISCAL_YEAR, value)
    .then((response) => {
      return dispatch(dispatchStateFiscal(response.data));
    })
    .catch((response) => {
      dispatch(dispatchStateFiscal([]));
    });
};
